import { environment } from 'environments/environment';
import { JwtAuthService } from '../../shared/services/auth/jwt-auth.service';
import { Injectable, Renderer2, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { getQueryParam } from '../helpers/url.helper';
import { ThemeService } from './theme.service';

export interface ILayoutConf {
  navigationPos?: string; // side, top
  sidebarStyle?: string; // full, compact, closed
  sidebarCompactToggle?: boolean; // sidebar expandable on hover
  sidebarColor?: string; // Sidebar background color http://demos.ui-lib.com/egret-doc/#egret-colors
  dir?: string; // ltr, rtl
  isMobile?: boolean; // updated automatically
  useBreadcrumb?: boolean; // Breadcrumb enabled/disabled
  breadcrumb?: string; // simple, title
  topbarFixed?: boolean; // Fixed header
  footerFixed?: boolean; // Fixed Footer
  topbarColor?: string; // Header background color http://demos.ui-lib.com/egret-doc/#egret-colors
  footerColor?: string // Header background color http://demos.ui-lib.com/egret-doc/#egret-colors
  matTheme?: string; // material theme. egret-blue, egret-navy, egret-dark-purple, egret-dark-pink
  perfectScrollbar?: boolean;
  isEmpresaRemota?: boolean;
  isEmpresaAutomacao?: boolean;
  isEmpresaServicoMecanico?: boolean;
  isEmpresaConsultoria?: boolean;
  isEmpresaTransporte?: boolean;
  isEmpresaMDFe?: boolean;
  isEmpresaPontoAtendimento?: boolean;
  isServidorLocal?: boolean;
  isLojaOnLine?: boolean;
  isRepresentante?: boolean;
}
export interface ILayoutChangeOptions {
  duration?: number;
  transitionClass?: boolean;
}
interface IAdjustScreenOptions {
  browserEvent?: any;
  route?: string;
}

@Injectable({
  providedIn: 'root'
})

export class LayoutService implements OnInit {
  public layoutConf: ILayoutConf;
  layoutConfSubject: BehaviorSubject<ILayoutConf> = new BehaviorSubject<ILayoutConf>({});
  layoutConf$;
  public isMobile: boolean;
  public currentRoute: string;
  public fullWidthRoutes = ['shop'];

  ngOnInit(): void {

    //set isEmpresaConsultoria par true
    this.layoutConf.isEmpresaConsultoria = true;
    this.layoutConfSubject.next(this.layoutConf);

    this.layoutConf$ = this.layoutConfSubject.asObservable();
  }


  constructor(
    private themeService: ThemeService,
    private jwtAuthService: JwtAuthService,
    ) {
    this.layoutConfSubject = new BehaviorSubject<ILayoutConf>(this.layoutConf);
    this.layoutConf$ = this.layoutConfSubject.asObservable();
    this.setAppLayout(
      // ******** SET YOUR LAYOUT OPTIONS HERE *********
      {
        navigationPos: 'side', // side, top
        sidebarStyle: 'full', // full, compact, closed
        sidebarColor: 'black', // http://demos.ui-lib.com/egret-doc/#egret-colors
        sidebarCompactToggle: false, // applied when "sidebarStyle" is "compact"
        dir: 'ltr', // ltr, rtl
        useBreadcrumb: true,
        topbarFixed: false,
        footerFixed: false,
        topbarColor: 'cyan', // http://demos.ui-lib.com/egret-doc/#egret-colors
        footerColor: 'white', // http://demos.ui-lib.com/egret-doc/#egret-colors
        matTheme: 'egret-blue', // egret-blue, egret-navy, egret-light-purple, egret-dark-purple, egret-dark-pink
        breadcrumb: 'simple', // simple, title
        perfectScrollbar: true,
        isMobile: true

      }
    );

    this.jwtAuthService.getItem().subscribe((item) => {


      if(item?.empresaRemota!== undefined && item?.empresaRemota!== null){
        this.layoutConf.isEmpresaRemota    = item.empresaRemota?.empresaRemota;
        this.layoutConf.isEmpresaAutomacao = item.empresaRemota?.empresaAutomacao??false;
        this.layoutConf.isEmpresaServicoMecanico = item.empresaRemota?.empresaServicosMecanico??false;
        this.layoutConf.isEmpresaTransporte = item.empresaRemota?.empresaTransporte??false;
        this.layoutConf.isEmpresaConsultoria = item.empresaRemota?.empresaConsultoria??false;
        this.layoutConf.isEmpresaMDFe      = item.empresaRemota?.empresaMDFe??false;
        this.layoutConf.isEmpresaPontoAtendimento = item.empresaRemota?.empresaPontoAtendimento??false;
        this.layoutConf.isLojaOnLine       = item.empresaRemota?.lojaOnline??false;
        this.layoutConf.isServidorLocal    = item.empresaRemota?.servidorLocal??false;
        this.layoutConf.isRepresentante = (item?.cadastroVendedorId > 0);
      }else{
        this.layoutConf.isEmpresaRemota    = false;
        this.layoutConf.isEmpresaAutomacao = false;
        this.layoutConf.isEmpresaTransporte = false;
        this.layoutConf.isEmpresaMDFe      = false;
        // intranet: sem empresa remota, vale a configuração da filial
        this.layoutConf.isEmpresaPontoAtendimento = item?.pontoAtendimentoAtivo === true;
        // idem para a oficina (Ordem de Serviço): módulo é opt-in, então só liga marcado
        this.layoutConf.isEmpresaServicoMecanico = item?.servicosMecanicoAtivo === true;
        this.layoutConf.isEmpresaConsultoria = false;
        this.layoutConf.isLojaOnLine       = false;
        this.layoutConf.isRepresentante = (item?.cadastroVendedorId > 0);
      }
    
      if (this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.item$?.value, 'ROLE_ADMIN_READ') || this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.itemRemoto$?.value, 'ROLE_ADMIN_READ')) {
        this.layoutConf.isRepresentante = false;
      } else {
        this.layoutConf.isRepresentante = true;
      }

      if(this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.item$?.value, 'ROLE_ROOT')  ){
        this.layoutConf.isRepresentante = false;
      }

      this.layoutConfSubject.next(this.layoutConf);

      
      console.log(`ROLE_ADMIN_READ >>>>> ${(item?.cadastroVendedorId > 0 ||(!this.jwtAuthService.isRoleAuthorized(this.jwtAuthService?.itemRemoto$?.value, 'ROLE_ADMIN_READ')))}`)
      
      console.log(` layoutConf: <<<<<<<<<<<< >>>>>>>>> ${JSON.stringify( this.layoutConf)}`);

    });

  }

  /**
   * A empresa atende no salão (mapa de pontos de atendimento, comanda, preparo)?
   *
   * <p>Esconde SÓ quando a sessão afirma, explicitamente, que não. Com {@code empresaRemota} vale a
   * flag do cadastro da empresa; sem ela (toda instalação local/intranet) vale
   * {@code item.pontoAtendimentoAtivo}, configurado na filial. Nulo = não configurado e continua
   * liberado: ausência de informação não vira negativa, senão o recurso some onde mais se usa.</p>
   *
   * <p>Fora de produção devolve sempre true: a empresa de desenvolvimento raramente está marcada, e
   * sem isso não há como abrir as telas para testá-las.</p>
   */
  empresaAtendeNoSalao(): boolean {
    if (!environment.production) {
      return true;
    }
    const item: any = this.jwtAuthService?.item$?.value;
    const empresa: any = item?.empresaRemota;
    if (empresa === null || empresa === undefined) {
      // intranet: vale a configuração da filial; sem configuração continua liberado
      return item?.pontoAtendimentoAtivo !== false;
    }
    return empresa.empresaPontoAtendimento !== false;
  }

  setAppLayout(layoutConf: ILayoutConf) {
    this.layoutConf = { ...this.layoutConf, ...layoutConf };
    this.applyMatTheme(this.layoutConf.matTheme);

    // ******* Only for demo purpose ***
    this.setLayoutFromQuery();
    // **********************
  }

  publishLayoutChange(lc: ILayoutConf, opt: ILayoutChangeOptions = {}) {
    if (this.layoutConf.matTheme !== lc.matTheme && lc.matTheme) {
      this.themeService.changeTheme(this.layoutConf.matTheme, lc.matTheme);
    }

    this.layoutConf = Object.assign(this.layoutConf, lc);
    this.layoutConfSubject?.next(this.layoutConf);
  }

  applyMatTheme(theme) {
    this.themeService.applyMatTheme(this.layoutConf.matTheme);
  }

  setLayoutFromQuery() {
    const layoutConfString = getQueryParam('layout');
    const prevTheme = this.layoutConf.matTheme;
    try {
      this.layoutConf = JSON.parse(layoutConfString);
      this.themeService.changeTheme(prevTheme, this.layoutConf.matTheme);
    } catch (e) {}
  }

  adjustLayout(options: IAdjustScreenOptions = {}) {
    let sidebarStyle: string;
    this.isMobile = this.isSm();
    this.currentRoute = options.route || this.currentRoute;
    const shouldKeepCompact = this.layoutConf?.sidebarStyle === 'compact' || !!this.layoutConf?.sidebarCompactToggle;
    sidebarStyle = this.isMobile ? 'closed' : (shouldKeepCompact ? 'compact' : 'full');

    if (this.currentRoute) {
      this.fullWidthRoutes.forEach(route => {
        if (this.currentRoute.indexOf(route) !== -1) {
          sidebarStyle = 'closed';
        }
      });
    }

    this.publishLayoutChange({
      isMobile: this.isMobile,
      sidebarStyle: sidebarStyle
    });
  }
  isSm() {
    return window.matchMedia(`(max-width: 959px)`).matches;
  }
}
